import {
  Apiv2BlobGetRequest,
  Apiv2GetRequest,
  Apiv2PostRequest,
  Apiv2DeleteRequest,
  Apiv2PutRequest,
  Apiv2PostMultipart,
} from '../../api-v2';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Daftar Lembur Karyawan',
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_lembur_karyawan',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'kode_lembur',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'nm_karyawan',
        label: 'Nama Karyawan',
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
      },
      {
        key: 'nm_dept',
        label: 'Dept',
      },
      {
        key: 'tgl_awal',
        label: 'Tgl Lembur',
        sortable: true,
      },
      {
        key: 'tgl_akhir',
        label: 'Jam Lembur',
      },
      {
        key: 'jam_lembur',
        label: 'Total Jam',
      },
      {
        key: 'nominal_lembur',
        label: 'Nominal',
      },
      {
        key: 'ket_lembur',
        label: 'Keterangan',
      },
      {
        key: 'status_lembur',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      tanggal: '',
      start_time: '',
      end_time: '',
      file_lembur: '',
      ket_lembur: '',
      nominal_lembur: 0,
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeLemburKaryawan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchLemburKaryawan(context, params = null) {
    let result = await Apiv2GetRequest(`lembur-karyawan`, params);
    return !result.error ? result.data.object : [];
  },

  async getTotalNotApproveLembur(context, params = null) {
    let result = await Apiv2GetRequest(`lembur-karyawan/not-approve`, params);
    return !result.error ? (result.data.object ? result.data.object : 0) : 0;
  },

  async getListLemburKaryawan({ commit, state }, payload = {}) {
    commit('changeLemburKaryawan', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await Apiv2BlobGetRequest(`lembur-karyawan`, params);
      commit('changeLemburKaryawan', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_lembur_karyawan.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        commit('changeLemburKaryawan', {
          loading: false,
        });

        return true;
      }
    } else {
      let result = await Apiv2GetRequest(`lembur-karyawan`, params);
      commit('changeLemburKaryawan', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailLemburKaryawan({ commit }, payload = null) {
    commit('changeLemburKaryawan', {
      loading: true,
    });

    let result = await Apiv2GetRequest(`lembur-karyawan/${payload.id}`);
    commit('changeLemburKaryawan', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadFileLembur({ commit, state }, payload) {
    commit('changeLemburKaryawan', {
      loading: true,
    });

    const { data } = state;
    const result = await Apiv2PostMultipart(`upload-files`, payload);
    commit('changeLemburKaryawan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeLemburKaryawan', {
        form: {
          ...data.form,
          file_lembur: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeLemburKaryawan', {
      loading: true,
    });

    const { data } = state;
    let result = await Apiv2PostRequest(`lembur-karyawan/import`, {
      items: data.import_form || [],
    });

    commit('changeLemburKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createLemburKaryawan({ commit, state, dispatch }) {
    commit('changeLemburKaryawan', {
      loading: true,
    });

    let result = await Apiv2PostRequest(`lembur-karyawan`, state.data.form);
    commit('changeLemburKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateLemburKaryawan({ commit, state, dispatch }, payload = null) {
    commit('changeLemburKaryawan', {
      loading: true,
    });

    let result = await Apiv2PutRequest(
      `lembur-karyawan/${payload.id}`,
      state.data.form,
    );

    commit('changeLemburKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteLemburKaryawan({ commit, dispatch }, payload = null) {
    commit('changeLemburKaryawan', {
      loading: true,
    });

    let result = await Apiv2DeleteRequest(`lembur-karyawan/${payload.id}`);
    commit('changeLemburKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async approveLemburKaryawan({ commit, dispatch }, payload = null) {
    commit('changeLemburKaryawan', {
      loading: true,
    });

    let result = await Apiv2GetRequest(
      `lembur-karyawan/${payload.id}/${payload.status}`,
    );
    commit('changeLemburKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
